<template>
  <a>
    <router-link v-if="account != null" :to = "{ name:'MyspaceTimeLine', params:{ accountId: props.accountId} }">
      <img v-if="props.accountId != null && Boolean(props.hasImg)" :src="imgUrl" :alt="props.accountName">
      <img v-else-if="props.accountId != null && !Boolean(props.hasImg)" :src="noUserIcon" :alt="props.accountName">
    </router-link>
    <div v-else>
      <img v-if="props.accountId != null && Boolean(props.hasImg)" :src="imgUrl" :alt="props.accountName">
      <img v-else-if="props.accountId != null && !Boolean(props.hasImg)" :src="noUserIcon" :alt="props.accountName">
    </div>
  </a>
</template>
<script setup>
import Common from '../../js/common.js';
import Global from '../../js/constant.js';
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex';

const $store = useStore()

// props
const props = defineProps({
  hasImg : {
    type : Boolean,
    required: true
  },
  accountId : {
    type : Number,
    required : false
  },
  accountName : {
    type : String,
    required : false
  },  
})

const account = computed(() => $store.state.core.account)
const imgUrl = computed(() => `/app/images/account/${props.accountId}`)
const noUserIcon = computed(() => `${Common.getBaseUrl()}${Global.static_path}/images/common/user_icon.png`)

</script>